import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=4b3b44f2&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4b3b44f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!D:\\Program Files\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3b44f2",
  null,
  false,
  components,
  renderjs
)

export default component.exports